<template>
    <div class="context1" v-show="step == 1">
        <div class="tips" v-if="props.type == 5">
            <iconpark-icon name="huaban10"></iconpark-icon>
            为确保账户及资金安全请填写您的企业对公账户信息，系统将向您的账户随机转入(0.01-2.00)元款项，请确保您能查询到打款金额填写正确即可通过认证
        </div>
        <div class="tips" v-if="props.type == 6">
            <iconpark-icon name="huaban10"></iconpark-icon>
            为确保账户及资金安全请填写您的企业对公账户信息，系统将随机产生(0.01-2.00)元款项，请确保您的账户向平台对公账户转入相应打款金额即可通过认证。
        </div>
        <div>
            <div class="flex">
                <van-form :model="params" ref="formRef1" class="form-col">
                    <van-cell-group inset>
                        <van-field v-model="params.enterTypeText" is-link readonly label="企业类型" placeholder="请选择企业类型"
                            @click="showEnterTypePicker = true" />
                        <van-field v-model="params.enterName" label="企业名称" placeholder="请输入企业名称" />
                        <template v-if="props.type == 4">
                            <van-field v-model="params.enterLegalperson" label="企业法人" placeholder="请输入企业法人姓名" />
                            <van-field v-model="params.enterMobile" type="tel" label="企业电话" placeholder="请输入企业电话" />
                            <van-field v-model="params.enterEmail" label="企业邮箱" placeholder="请输入企业邮箱" />
                        </template>
                        <van-field v-model="params.businessLicense" label="企业执照注册号" placeholder="请输入企业执照注册号" />
                        <template v-if="props.type >= 5">
                            <van-field v-model="params.manager" label="企业联系人姓名"  placeholder="请输入企业联系人姓名" />
                            <van-field v-model="params.managerMobile" type="tel" label="联系人手机号码"
                                placeholder="请输入手机号码" />
                        </template>
                        <van-field label="企业执照">
                            <template #input>
                                <div class="idcard"
                                    :style="{ backgroundImage: params.businessPhoto ? 'url(' + params.businessPhoto + ')' : '' }">
                                    <input type="file" @change="e => uploadImage(e, true)">
                                    <div class="content flex-center" v-if="!params.businessPhoto">
                                        <img src="@/assets/images/empty.png" />
                                        <p>营业执照扫描件</p>
                                    </div>
                                </div>
                            </template>
                        </van-field>

                        <template v-if="props.type == 4">
                            <van-field v-model="params.manager" label="企业联系人姓名"  placeholder="请输入企业联系人姓名" />
                            <van-field v-model="params.managerIdcard" label="联系人身份证号码" placeholder="请输入身份证号码" />
                            <van-field v-model="addressText" is-link readonly label="联系地址" placeholder="请选择省市区"
                                @click="showAddressPicker = true" />
                            <van-field v-model="params.address" label=" " placeholder="请输入详细地址" />
                            <van-field v-model="params.managerMobile" type="tel" label="联系方式" placeholder="请输入手机号码" />
                        </template>
                        <template v-if="props.type == 5">
                            <van-field v-model="params.accountName" label="账户名称" placeholder="请输入账户名称" />
                            <van-field v-model="params.blankName" label="开户银行" placeholder="请输入开户银行" />
                            <van-field v-model="params.subBlankName" label="开户银行支行" placeholder="请输入开户银行支行" />
                            <van-field v-model="params.blankNumber" label="银行账号" placeholder="请输入银行账号" />
                            <van-field v-model="params.blankPhone" type="tel" label="通知手机号" placeholder="请输入通知手机号" />
                        </template>
                        <template v-if="props.type == 6">
                            <van-field v-model="params.accountName" label="账户名称" placeholder="请输入账户名称" />
                            <van-field v-model="params.blankName" label="开户银行" placeholder="请输入开户银行" />
                            <van-field v-model="params.subBlankName" label="开户银行支行" placeholder="请输入开户银行支行" />
                            <van-field v-model="params.blankNumber" label="银行账号" placeholder="请输入银行账号" />
                        </template>
                    </van-cell-group>
                </van-form>

            </div>
        </div>

        <footer>
            <span class="auth-btn limit plain" @click="emit('prev')">上一步</span>
            <span class="auth-btn limit" @click="confirm">提交审核</span>
        </footer>
    </div>

    <div v-show="step == 2" class="context2">
        <img src="@/assets/images/clock.png" alt="">
        <h4 style="color: #0A84FF;">打款验证</h4>
        <p>请向收款账户转入系统指定金额，请您确保转账金额在有效期内且数额一致则验证通过</p>
        <p style="width: 350rem;">收款账户:东方金典数字科技(湖南)有限公司</p>
        <p style="width: 350rem;">开户银行:招商银行</p>
        <p style="width: 350rem;">开户银行行支行:长沙科技园支行</p>
        <p style="width: 350rem;">银行账号:6221**** 2566</p>
        <p style="width: 350rem;">转入金额: <b>0.02元</b></p>
        <p style="width: 350rem;" class="tips">请确保转入金额与系统指定金额一致，否则无法通过打款认证</p>
        <footer class="btn-group">
            <span class="auth-btn" @click="emit('prev')">更换认证方式</span>
            <span class="auth-btn" @click="step = 1">修改账户信息</span>
            <span class="auth-btn primary" @click="confirm">已打款提交审核</span>
        </footer>
    </div>

    <van-popup v-model:show="showEnterTypePicker" position="bottom">
        <van-picker :columns="enterTypeColumns" @confirm="onEnterTypeConfirm" @cancel="showEnterTypePicker = false" />
    </van-popup>

    <van-popup v-model:show="showAddressPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="onAddressConfirm" @cancel="showAddressPicker = false" />
    </van-popup>

</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import axios from 'axios';
import { showNotify } from 'vant'
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { client } from '@/request/oss'

const store = useStore()
const props = defineProps({
    type: Number
})
const emit = defineEmits(['prev', 'next'])
const step = ref(1)
const formRef1 = ref(null)
const formRef2 = ref(null)

const showEnterTypePicker = ref(false)
const showAddressPicker = ref(false)
const enterTypeColumns = ref([])
const areaList = reactive({
    province_list: {},
    city_list: {},
    county_list: {}
})
const addressText = ref('')

const params = reactive({
    enterType: '',
    enterTypeText: '',
    enterName: '',
    enterEmail: '',
    enterLegalperson: '',
    managerAddress: '',
    enterMobile: '',
    manager: '',
    managerIdcard: '',
    managerMobile: '',
    businessLicense: '',
    businessPhoto: '',
    accountName: '',
    blankName: '',
    subBlankName: '',
    blankNumber: '',
    blankPhone: '',
    province: '',
    city: '',
    area: '',
    address: '',
    license: ''
})

onMounted(() => {
    axios.get('https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/data/ChinaCitys.json').then(res => {
        const data = res.data
        const provinceList = {}
        const cityList = {}
        const countyList = {}
        data.forEach(p => {
            provinceList[p.code] = p.province
            p.citys.forEach(c => {
                cityList[c.code] = c.city
                c.areas.forEach(a => {
                    countyList[a.code] = a.area
                })
            })
        })
        Object.assign(areaList, { province_list: provinceList, city_list: cityList, county_list: countyList })
    })
    http.get('/app-api/system/dict-data/type?type=enter_type').then(res => {
        enterTypeColumns.value = res.map(item => ({ text: item.label, value: item.value }))
    })
})

const onEnterTypeConfirm = ({ selectedOptions }) => {
    params.enterType = selectedOptions[0].value
    params.enterTypeText = selectedOptions[0].text
    showEnterTypePicker.value = false
}

const onAddressConfirm = (values) => {
    params.province = values.selectedOptions[0].text
    params.city = values.selectedOptions[1].text
    params.area = values.selectedOptions[2].text
    addressText.value = `${params.province} ${params.city} ${params.area}`
    showAddressPicker.value = false
}

const uploadImage = (e, type) => {
    const file = e.target.files[0]
    const extName = file.name.slice(file.name.lastIndexOf('.'))
    client.setBucket('dfsk-3d')
    client.put(`cover/${Date.now() + extName}`, file).then(result => {
        params.businessPhoto = result.url
    })
}

const confirm = () => {
    if (props.type == 6) {
        step.value = 2
    }
    const data = {
        id: store.state.login.userInfo.id,
        enterType: params.enterType,
        enterName: params.enterName,
        enterEmail: params.enterEmail,
        enterLegalperson: params.enterLegalperson,
        managerAddress: params.province + ',' + params.city + ',' + params.area + ',' + params.address,
        enterMobile: params.enterMobile,
        manager: params.manager,
        managerIdcard: params.managerIdcard,
        managerMobile: params.managerMobile,
        businessLicense: params.businessLicense,
        businessPhoto: params.businessPhoto,
        userType: 1
    }
    
    http.put('/app-api/member/user/updateUserAuthInfo', data).then(res => {
        if (res) {
            showNotify({ type: 'success', message: '提交成功' })
            emit('next', 2)
        } else {
            showNotify({ type: 'danger', message: res.msg || '提交失败' })
        }
    })
}
</script>

<style scoped lang="scss">
.auth-btn {
    width: 160rem;
    height: 40rem;
    background: #000;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);

    &.limit {
        width: 160rem;
    }

    &.plain {
        background-color: #fff;
        color: #000;
    }

    &.primary {
        background: #000;
        color: #fff;
    }
}

.context1 {
    width: 100%;
    margin: 50rem 0;
    background-color: #fff;
    border-radius: 10rem;
    overflow: hidden;
    padding: 20rem 0;
    text-align: center;

    .tips {
        padding: 20rem;
        background: #FFF7E6;
        color: #FF9800;
        font-size: 14rem;
        line-height: 1.6;

        iconpark-icon {
            margin-right: 10rem;
        }
    }

    .flex {
        display: flex;
        gap: 30rem;

        .form-col {
            flex: 1;
        }

        .idcard {
            width: 200rem;
            height: 130rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;

            input {
                opacity: 0;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            .content {
                width: 100%;
                height: 100%;
                flex-direction: column;

                img {
                    width: 40rem;
                }

                p {
                    font-size: 12rem;
                    color: #999;
                    margin-top: 10rem;
                }
            }
        }
    }

    footer {
        display: flex;
        justify-content: space-evenly;
        padding: 30rem 0;
    }

    ::v-deep(.van-cell) {
        padding: 10rem 0;
    }

    ::v-deep(.van-field__label) {
        font-size: 14rem;
    }

    ::v-deep(.van-cell__value) {
        input {
            font-size: 14rem;
        }
    }
}

.context2 {
    width: 100%;
    margin-top: 50rem;
    background-color: #fff;
    border-radius: 10rem;
    overflow: hidden;
    padding: 30rem;
    text-align: center;
    margin-bottom: 50rem;
    img {
        width: 80rem;
        margin-top: 50rem;
    }

    h4 {
        margin: 20rem 0;
        font-weight: bold;
        font-size: 24rem;
    }

    p {
        color: #383838;
        line-height: 40rem;
        text-align: left;
        margin: 0 auto;
    }

    .tips {
        color: #D43030;
        margin-top: 20rem;
    }

    footer.btn-group {
        display: flex;
        justify-content: space-evenly;
        margin-top: 50rem;
        flex-wrap: wrap;
        gap: 20rem;

        .auth-btn {
            flex: 1;
            min-width: 180rem;
        }
    }
}
</style>
